import { makeArrayFromLength } from "oolib";
import { genHash } from "./genHash";

export const prepInitValueFromConfigIfNoValue = ({
  _value,
  config,
  defaultColWidth,
}) => {
  //if colHeaderData is defined then that decides the noOfCols.
  const noOfCols = config.colHeaderData?.length || parseInt(config.noOfCols) || 3;
  const noOfRows = config.rowHeaderData?.length || parseInt(config.noOfRows) || 3;

  const value =
    _value?.data?.length > 0 //value exists in the correct shape
      ? _value
      : Array.isArray(_value) && _value.length > 0 //value exists but in deprecated shape
      ? {
          data: _value,
          colWidthConfig: getInitColWidthConfigs({
            noOfCols: _value[0].cellData.length,
            defaultColWidth,
          }),
        } //backwards compat
      : { //else value does not exist at all
          data: [
            ...insertRowCellIdsAndComp({
              noOfRows,
              noOfCols,
              blockConfig: config.blockConfig
            }),
          ],
          colWidthConfig: getInitColWidthConfigs({ noOfCols, defaultColWidth }),
        };

  return {
    value,
    enableColActions: config.colHeaderData ? false : true, // meaning if config.colHeaderData is defined, then no actions are possible on col
    enableRowActions: config.rowHeaderData ? false : true, // meaning if config.rowHeaderData is defined, then no actions are possible on row
    canToggleColHeaderStyle: !!!config.colHeaderData, // meaning its true if no config.colHeaderData is defined. else false
  };
};

const getInitColWidthConfigs = ({ noOfCols, defaultColWidth }) => {
  return makeArrayFromLength(noOfCols)
    .map((d, i) => ({
      colId: `col_${i}`,
      width: defaultColWidth + "px",
    }))
    .reduce((a, b) => ({ ...a, [b.colId]: b.width }), {});
};

const insertRowCellIdsAndComp = ({ noOfRows, noOfCols, blockConfig = [] }) => {
  return makeArrayFromLength(noOfRows).map(() => ({
    id: `row_${genHash(8)}`,
    cellData: makeArrayFromLength(noOfCols).map((d,i) => ({
      id: `cell_${genHash(8)}`,
      ...(blockConfig[i]?.comp ? {comp: blockConfig[i].comp, props: blockConfig[i].props || {}} : {})
    })),
  }));
};
